module.exports = __webpack_public_path__ + "img/SH.1e0e6221.png";